import { createBrowserHistory } from "history";
//On redéclare ensuite les méthodes
export default createBrowserHistory();